'use client';

import { FC, PropsWithChildren } from 'react';
import { Portal } from 'components/pcc-components';
import { ROOT_PORTALS } from 'constants/targets';

export const NotificationsDrawerWrapper: FC<PropsWithChildren> = ({
  children
}) => {
  return <Portal id={ROOT_PORTALS}>{children}</Portal>;
};
